import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { useMutation } from '@/utils/api';

interface ProvisionResponse {
  org_id: string;
  message: string;
}

export function useAegisProvision(onSuccess?: () => void) {
  const axios = useAxios();

  return useMutation<ProvisionResponse, Error, { tenantName: string }>({
    defaultErrorMessage: 'Failed to provision Aegis enrollment.',
    getErrorFromResponse: true,
    mutationFn: async ({ tenantName }) => {
      const response = await axios.post('/aegis/provision', {
        tenant_name: tenantName,
      });
      return response.data;
    },
    onSuccess: data => {
      toast.info(`Aegis provisioning submitted — org: ${data.org_id}`);
      onSuccess?.();
    },
  });
}
